import React, { useEffect, useState } from "react";
import {Table, Row, Col, Card, CardBody, Modal, CardTitle, ModalHeader, ModalBody, FormGroup, Label, InputGroup, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import "flatpickr/dist/themes/material_blue.css";
import { PhoneInput } from 'react-international-phone';
import { json, Link } from "react-router-dom";
const Partenaires = () => {
  document.title = "AMAVIE | Application de gestion de Afrika Mobility";
  const [loadingBord, setLoadingBord]=useState(false)
  const [companies, setCompanies]= useState([])
  const [total, setTotal]=useState(0)
  const [totalPage, setTotalPage]= useState(0)
  const [currAttestation, setCurrAttestation]= useState(0)
  const [currPage, setCurrPage]= useState(0)
  const [company, setCompany]= useState(null)
  const [search, setSearch]= useState(null)
  const [modal_beneficiary, setmodal_beneficiary] = useState(false);
  const [errorcompany, setErrorcompany]= useState(null)
  const [successcompany, setSuccesscompany]= useState(null)

  //FOR company FORM
  const [companyName, setCompanyName]= useState("")
  const [companyPhone, setCompanyPhone]= useState("")
  const [companyEmail, setCompanyEmail]= useState(null)
  
  const checkcompanyInput = () => {
    if (!companyName || !companyName.trim()) { setErrorcompany('Veuillez entrer le nom de l\'entreprise svp'); return false;}
    if (!companyPhone || !companyPhone.trim()) { setErrorcompany('Veuillez entrer le téléphone du company svp'); return false;}
    if (!companyEmail || !companyEmail.trim()) { setErrorcompany('Veuillez entrer le mail du company svp'); return false;}
      setErrorcompany("")     
      return true;
  };
  
  const tog_partner = () => { setmodal_beneficiary(!modal_beneficiary); removeBodyCss(); };
  const removeBodyCss = () => { document.body.classList.add("no_padding"); };

  const loadCompanies=(page, search)=> {
    setLoadingBord(true)
    fetch(`${url.BACKEND_URL}/companies?page=${page}&size=20`, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      console.log(responseJson);
      if (responseJson.status==200) { 
        setCompanies(responseJson.data)
        setLoadingBord(false)
    } else { setCompanies([]); setLoadingBord(false) }
    }) .catch((error) => { setLoadingBord(false) });
  };
    
    const saveCompany= ()=>{
      const inputError = checkcompanyInput();
      if (inputError) {
        const jsonData= JSON.stringify({ name: companyName, phone: companyPhone, email: companyEmail });
        // console.log(jsonData);
        fetch(`${url.BACKEND_URL}/companies`, { method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: jsonData })
        .then((response) => response.json())
        .then((responseJson) => {
          console.log("Company", responseJson.data);
          if (responseJson.status==200) {  
            setCompanies([responseJson.data, ...companies]); 
            setTimeout(() => { tog_partner(); setCompanyEmail(""); setCompanyPhone(""); setCompanyName("") }, 500); }
          else { setErrorcompany(responseJson.message) }
        }) .catch((error) => { console.log(error); }); 
      }
    }
    
  useEffect(()=>{ loadCompanies(0, null); }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="AMAVIE" title="Partenaires" />
          <Modal isOpen={modal_beneficiary} toggle={tog_partner} size="lg">
            <ModalHeader className="mt-0" toggle={tog_partner}>Formulaire de création d'un partenaires</ModalHeader>
            <ModalBody>
              <form>
                <Row>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Nom de l'entreprise</Label>
                      <input className="form-control" onChange={(event)=>{ setCompanyName(event.target.value); }} placeholder="Nom de l'entreprise" type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <FormGroup className="mb-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="formrow-firstname-input">Numéro de téléphone</label>
                        <PhoneInput
                          defaultCountry="ci"
                          value={companyPhone}
                          onChange={setCompanyPhone}
                          inputStyle={{ width: "100%" }} 
                          />
                      </div>
                    </FormGroup>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Email</Label>
                      <input className="form-control" placeholder="Email du company" onChange={(event)=>{ setCompanyEmail(event.target.value); }} type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ marginTop: 20}}>
                    <strong className="text-danger">{errorcompany}</strong>
                    <strong className="text-success">{successcompany}</strong>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ marginTop: 20}}>
                    <Button color="primary" style={{ fontSize: 20  }} className="form-control btn btn-primary waves-effect waves-light" onClick={()=>saveCompany()}>Ajouter l'entreprise</Button>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>

          <Row>
            <CardTitle className="h4">Gestion des partenaires</CardTitle>
            <Col md={4}>
              <div className="mb-3">
                <Label>Recherche</Label>
                <input className="form-control" placeholder="Rechercher" onChange={(event)=>loadCompanies(0, event.target.value)} type="text" defaultValue="" id="example-datetime-local-input"/>
              </div>
            </Col>
            <Col md={2}>
              <div className="mb-3">
                <Label style={{ visibility: "hidden" }}>--</Label>
                <Button color="primary" className="form-control btn btn-primary waves-effect waves-light" onClick={()=>loadCompanies(0, search)}><i className="fas fa-search"></i> Rechercher</Button>
              </div>
            </Col>
            <Col md={3}>
              
            </Col>
             <Col xl={3}>
                <Label style={{ visibility: "hidden" }}>--</Label>
                <Link color="primary" onClick={tog_partner} className="form-control btn btn-warning waves-effect"><i className="fas fa-company-plus"></i> Créer une entreprise partenaire</Link>
              </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <div className="table-responsive">
                    <Table className="table mb-0" style={{fontSize: 15}}>
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Nom</th>
                          <th>Contact</th>
                          <th>Email</th>
                          {/* <th>Détails</th> */}
                        </tr>
                      </thead>
                      <tbody>
                         {companies.map((item, key)=>(
                            <tr>
                              <td>{item?.id}</td>
                              <td>{item?.name}</td>
                              <td>{item?.phone}</td>
                              <td>{item?.email}</td>
                              {/* <td><a className="fas fa-book" onClick={()=>{setTimeout(() => { tog_detail_beneficiary(item)}, 400);}}></a></td> */}
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Partenaires;
